import React, {ReactElement} from "react";
import {useTranslation} from "react-i18next";
import {useCartItemQuantity} from "../hooks/useCartItemQuantity";
import {QuantityFieldsData} from "../types";
import {MinimumOrderQuantityAdjustmentInfo} from "../../../ProductsList/MinimumOrderQuantity/MinimumOrderQuantity";
import {QuantityLimitError} from "../../QuantityLimit/QuantityLimitError";
import "../../../../Assets/Css/Pages/Cart/add_product.css";

type QuantityFieldsProps = {
    data: QuantityFieldsData;
    label: boolean;
    revers?: boolean;
};

type QuantityPackageFieldProps = {
    calculatedQuantity: number | string;
    hasMinimumOrderQuantityAdjustment: boolean;
    inputRef: React.RefObject<HTMLInputElement>;
};

type QuantityFieldProps = {
    handleInput: (event: React.FormEvent<HTMLInputElement>) => void;
    handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    handleWheel: (event: React.WheelEvent<HTMLInputElement>) => false;
    inputRef: React.MutableRefObject<HTMLInputElement>;
    label: boolean;
    maxInputQuantity: number;
};

export function QuantityFields({data, label, revers}: QuantityFieldsProps): ReactElement {
    const {
        calculatedQuantity,
        hasMinimumOrderQuantityAdjustment,
        hasQuantityLimitError,
        maxInputQuantity,
        handleInput,
        handleKeyDown,
        handleWheel,
        inputRef
    } = useCartItemQuantity(data);

    if (revers === true){
        return (
            <>
                <QuantityField
                    handleInput={handleInput}
                    handleKeyDown={handleKeyDown}
                    handleWheel={handleWheel}
                    inputRef={inputRef}
                    label={label}
                    maxInputQuantity={maxInputQuantity}
                />
                <QuantityPackageField
                    calculatedQuantity={calculatedQuantity}
                    hasMinimumOrderQuantityAdjustment={hasMinimumOrderQuantityAdjustment}
                    inputRef={data.product.ref}
                />
                {hasQuantityLimitError ? <QuantityLimitError /> : null}
            </>
        );
    }

    return (
        <>
        <QuantityPackageField
            calculatedQuantity={calculatedQuantity}
            hasMinimumOrderQuantityAdjustment={hasMinimumOrderQuantityAdjustment}
            inputRef={data.product.ref}
        />
            <QuantityField
                handleInput={handleInput}
                handleKeyDown={handleKeyDown}
                handleWheel={handleWheel}
                inputRef={inputRef}
                label={label}
                maxInputQuantity={maxInputQuantity}
            />
            {hasQuantityLimitError ? <QuantityLimitError /> : null}
        </>
    );
}

function QuantityPackageField({
    calculatedQuantity,
    hasMinimumOrderQuantityAdjustment,
    inputRef
}: QuantityPackageFieldProps): ReactElement {
    return (
        <div className="field quantity-package-field" >
            <input
                type="text"
                name="quantity-package"
                disabled={true}
                value={calculatedQuantity}
                ref={inputRef} />
            {hasMinimumOrderQuantityAdjustment ? <MinimumOrderQuantityAdjustmentInfo /> : null}
        </div>
    );
}

function QuantityField({handleInput, handleKeyDown, handleWheel, inputRef, label, maxInputQuantity}: QuantityFieldProps): ReactElement {
    const {t} = useTranslation();

    return (
        <div className="field" >
            {label ? <span>{t('products-list.quantity') + ': '}</span> : ''}

            <input
                inputMode="numeric"
                type="number"
                name="quantity"
                step={1}
                min="0"
                max={maxInputQuantity}
                ref={inputRef}
                onWheel={handleWheel}
                onWheelCapture={handleWheel}
                onKeyDown={handleKeyDown}
                onInput={handleInput} />
        </div>
    );
}
